"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationLabel = void 0;
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var icons_1 = require("../../../../gen-src/icons");
var CertifiedIconDefault_1 = __importDefault(require("../../../../gen-src/icons/CertifiedIconDefault"));
var LabelPopover_1 = require("../LabelPopover");
var useControlledPopover_1 = require("../shared/useControlledPopover");
function CertificationLabel(props) {
    var _a, _b;
    var popover = (0, useControlledPopover_1.useControlledPopover)({
        testId: props.testId,
        popoverProps: {
            title: certificationLabelTitle(props),
        },
        content: LabelPopover_1.LabelPopover,
        controlKind: (_b = (_a = props.controls) === null || _a === void 0 ? void 0 : _a.kind) !== null && _b !== void 0 ? _b : 'icon',
        iconProps: certificationIconProps,
        chipProps: certificationChipProps,
        onClick: props.onClick,
        loading: props.loading,
        props: __assign({}, props)
    });
    return popover !== null && popover !== void 0 ? popover : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.CertificationLabel = CertificationLabel;
function certificationIconProps(props, params) {
    return {
        getContent: props || params ? function (s) { return react_1.default.createElement(CertificationIcon, { state: s }); } : undefined,
        style: {
            height: '14px',
            width: '14px'
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function CertificationIcon(props) {
    var state = props.state;
    return (react_1.default.createElement("span", null, (state === null || state === void 0 ? void 0 : state.active) || (state === null || state === void 0 ? void 0 : state.hover) || (state === null || state === void 0 ? void 0 : state.selected) || false ?
        react_1.default.createElement(icons_1.SvgCertifiedIconActive, null) :
        react_1.default.createElement(icons_1.SvgCertifiedIconDefault, null)));
}
function certificationChipProps(props, params) {
    return {
        getContent: props || params ? function (s) { return react_1.default.createElement(CertificationChip, { state: s }); } : undefined,
        style: {
            borderRadius: '12.5px',
            height: '25px',
            width: '100px',
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function CertificationChip(props) {
    var state = props.state;
    return (react_1.default.createElement("div", { style: {
            backgroundColor: (state === null || state === void 0 ? void 0 : state.active) || (state === null || state === void 0 ? void 0 : state.hover) || (state === null || state === void 0 ? void 0 : state.selected) || false ? '#E5EDE4' : '#EDF5EC',
            color: '#666666',
            borderRadius: '12.5px',
            height: '25px',
            width: '100px',
        } },
        react_1.default.createElement("span", { style: { position: 'relative', top: '5px', fontWeight: 'bold', fontSize: '12px' } },
            react_1.default.createElement(CertifiedIconDefault_1.default, null)),
        react_1.default.createElement("span", { style: { position: 'relative', top: '3px', marginLeft: '4px', fontWeight: 'bold', fontSize: '12px' } }, Localize_1.Messages.DataQualityTypeCertified())));
}
function certificationLabelTitle(_) {
    return '';
}
//# sourceMappingURL=CertificationButton.js.map